import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import geolib from 'geolib';
import { getCenterForMapBasedOnCountryCode } from 'utils/localization/utils';

const getCenter = (markers) => {
  if (!markers || markers.length === 0) return null;

  const points = markers.map((m) => {
    return {
      latitude: m.coords.lat,
      longitude: m.coords.lng,
    };
  });

  const center = geolib.getCenter(points);
  if (center) {
    return {
      lat: parseFloat(center.latitude),
      lng: parseFloat(center.longitude),
    };
  }
  return null;
};

const defaultMapOptions = {
  zoomControl: true,
  mapTypeControl: false,
  scaleControl: true,
  streetViewControl: false,
  rotateControl: true,
  fullscreenControl: false,
};

const Map = withGoogleMap((props) => {
  const { markers, center, defaultZoom } = props;

  const defaultCenter =
    markers && markers.length > 0 ? getCenter(markers) : center;

  return (
    <GoogleMap
      ref={(map) => props.getMapComponent(map)}
      onResize={(m) => console.log('RESIZED FROM MAP', m)}
      defaultZoom={defaultZoom}
      defaultCenter={defaultCenter}
      center={defaultCenter}
      defaultOptions={defaultMapOptions}
    >
      {props.markers.map((marker, i) => {
        return (
          <Marker
            animation={google.maps.Animation.DROP}
            key={i}
            title={marker.title}
            noRedraw
            position={marker.coords}
            icon={marker.icon}
          />
        );
      })}
    </GoogleMap>
  );
});

export default class CargomaticMap extends Component {
  render() {
    console.log('this.props', this.props);
    return (
      <Map
        containerElement={
          <div style={{ height: this.props.height, width: '100%' }} />
        }
        mapElement={<div style={{ height: '100%' }} />}
        {...this.props}
      />
    );
  }
}

CargomaticMap.propTypes = {
  center: PropTypes.object,
  markers: PropTypes.array,
  height: PropTypes.string,
  defaultZoom: PropTypes.number,
  getMapComponent: PropTypes.func,
};

CargomaticMap.defaultProps = {
  center: getCenterForMapBasedOnCountryCode(),
  markers: [],
  height: 350,
  defaultZoom: 10,
  getMapComponent: (map) => {
    console.log('map component loaded');
  },
};
